import { useEffect } from "react";
import AchievementBadge from "./AchievementBadge";
import TurtleIcon from "../AssistantWidget/TurtleIcon";
import { Achievement } from "../../utils/achievements";
import styles from "./achievementUnlockedToast.module.scss";
import { useTranslation } from "react-i18next";
import { useProgressText } from "../../i18n/progressText";

type AchievementUnlockedToastProps = {
    achievement?: Achievement;
    level?: number;
    onDismiss: () => void;
    durationMs?: number;
};

// Render with a fresh `key` per achievement (see AchievementUnlockedNotice)
// so the auto-dismiss timer restarts for each one in a queue.
function AchievementUnlockedToast({ achievement, level, onDismiss, durationMs = 4000 }: AchievementUnlockedToastProps) {
    const { t } = useTranslation("common");
    const { achievementTitle } = useProgressText();
    useEffect(() => {
        const timer = setTimeout(onDismiss, durationMs);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.toast} role="status" aria-live="polite">
            {achievement ? <AchievementBadge achievement={achievement} size={44} /> : <TurtleIcon size={44} />}
            <span className={styles.toastText}>
                <span className={styles.toastEyebrow}>{level ? t("achievementToast.levelUp") : t("achievementToast.unlocked")}</span>
                <span className={styles.toastTitle}>{level ? t("achievementToast.levelReached", { level }) : achievement && achievementTitle(achievement)}</span>
            </span>
            <button type="button" className={styles.toastDismiss} onClick={onDismiss} aria-label={t("achievementToast.dismiss")}>
                ×
            </button>
        </div>
    );
}

export default AchievementUnlockedToast;
